import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_CLCLS_SERVICE_URL || "";

export const useDocState = () => {
    const [leadId, setLeadId] = useState("");
    const [dlState, setDlState] = useState(true);
    const [psState, setPsState] = useState(true);

    const getDocStates = useCallback(() => {
        if (!leadId) return;

        axios
            .post(API_URL + "/docs/get-status", {
                leadId,
            })
            .then((res) => {
                const data = res.data.data || [];
                const dl = data.find((doc: any) => doc.type === "Driver's Licence")?.status || "";
                const ps = data.find((doc: any) => doc.type === "Pay Stubs")?.status || "";

                setPsState(!["-None-", "Pending", "Not Available", "Denied"].includes(ps));
                setDlState(!["-None-", "Pending", "Not Available", "Denied"].includes(dl));
            })
            .catch((err) => {
                console.log("Fetch status error! Setting default!", err);
                setPsState(false);
                setDlState(false);
            });
    }, [leadId]);

    useEffect(() => getDocStates(), [getDocStates]);

    const setStatus = (type: string, state: boolean) => {
        if ("Pay Stubs" === type) setPsState(state);
        if ("Driver's License" === type) setDlState(state);
    };

    return {
        dlState,
        psState,
        setLeadId,
        setStatus,
    };
};
